import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow p-6 border border-gray-200 relative" }
const _hoisted_3 = { class: "absolute top-6 right-6" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  value: ""
}
const _hoisted_7 = {
  key: 1,
  value: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_10 = {
  key: 0,
  class: "mb-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded flex items-center justify-between"
}
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded mb-4 flex items-center"
}
const _hoisted_17 = {
  key: 2,
  class: "bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4 flex items-center justify-between"
}
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = {
  key: 3,
  class: "bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded mb-4 flex items-center justify-between"
}
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = {
  key: 4,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 flex items-center"
}
const _hoisted_22 = { class: "space-y-6" }
const _hoisted_23 = { class: "flex gap-5" }
const _hoisted_24 = { class: "space-y-6 flex-grow" }
const _hoisted_25 = {
  key: 0,
  class: "bg-white rounded-lg shadow p-6 border border-gray-200"
}
const _hoisted_26 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_27 = { class: "flex justify-between items-start" }
const _hoisted_28 = { class: "font-medium text-lg" }
const _hoisted_29 = {
  key: 0,
  class: "text-gray-600 mt-1"
}
const _hoisted_30 = { class: "bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded" }
const _hoisted_31 = { class: "mt-3 flex items-center text-sm text-gray-500" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "bg-white shadow-md rounded-lg p-6"
}
const _hoisted_34 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_35 = { class: "min-w-full bg-white" }
const _hoisted_36 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_37 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_38 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = {
  key: 0,
  class: "bg-white shadow-md rounded-lg p-6"
}
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "mb-4" }
const _hoisted_45 = { class: "border rounded p-4 bg-gray-50 h-64 overflow-auto relative" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "mb-4" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = { class: "flex justify-end space-x-3" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ChatbotInterface = _resolveComponent("ChatbotInterface")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_EmailPreviewModal = _resolveComponent("EmailPreviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[22] || (_cache[22] = _createElementVNode("label", {
            for: "process-selector",
            class: "mr-2 text-sm font-medium text-gray-700"
          }, "Forecasting Process:", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "process-selector",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProcessId) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleProcessChange && _ctx.handleProcessChange(...args))),
            class: "bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5",
            disabled: _ctx.loading
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("option", _hoisted_6, "Loading processes..."))
              : (_ctx.processes.length === 0)
                ? (_openBlock(), _createElementBlock("option", _hoisted_7, "No processes available"))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
              return (_openBlock(), _createElementBlock("option", {
                key: process.id,
                value: process.id
              }, _toDisplayString(process.name) + " (" + _toDisplayString(_ctx.formatProcessDate(process.start_date)) + ") ", 9, _hoisted_8))
            }), 128))
          ], 40, _hoisted_5), [
            [_vModelSelect, _ctx.selectedProcessId]
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[21] || (_cache[21] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-5 w-5 text-blue-500",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-xl font-semibold mb-4" }, "1. Upload Reporting Calendar", -1)),
      (_ctx.existingCalendar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[24] || (_cache[24] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                })
              ], -1)),
              _createElementVNode("span", null, [
                _cache[23] || (_cache[23] = _createTextVNode("A calendar has already been uploaded for this forecasting process: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.existingCalendar.name), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("input", {
          type: "file",
          id: "excel-template",
          accept: ".xlsx, .xls, .csv",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          class: "hidden",
          ref: "fileInput"
        }, null, 544),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args))),
          class: _normalizeClass([
            _ctx.existingCalendar
              ? 'bg-transparent text-blue-700 border border-blue-700 hover:bg-blue-50'
              : 'bg-blue-700 text-white hover:bg-blue-800',
            'px-4 py-2 rounded-md flex items-center transition-colors'
          ]),
          disabled: _ctx.isUploading
        }, [
          _cache[25] || (_cache[25] = _createElementVNode("svg", {
            class: "h-5 w-5 mr-2",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            })
          ], -1)),
          (_ctx.existingCalendar)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Replace Reporting Calendar"))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, "Upload Reporting Calendar"))
        ], 10, _hoisted_13)
      ]),
      (_ctx.isUploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[26] || (_cache[26] = [
            _createElementVNode("svg", {
              class: "animate-spin h-5 w-5 mr-2",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ], -1),
            _createElementVNode("span", null, "Processing file...", -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.uploadSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _cache[27] || (_cache[27] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M5 13l4 4L19 7"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.uploadSuccess), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearUploadSuccess && _ctx.clearUploadSuccess(...args))),
              class: "text-green-700 hover:text-green-900 focus:outline-none",
              "aria-label": "Close notification"
            }, _cache[28] || (_cache[28] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[29] || (_cache[29] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedFile.name), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args))),
              class: "text-blue-700 hover:text-blue-900 focus:outline-none",
              "aria-label": "Close notification"
            }, _cache[30] || (_cache[30] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.uploadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _cache[31] || (_cache[31] = _createElementVNode("svg", {
              class: "h-5 w-5 mr-2",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              })
            ], -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.uploadError instanceof Object && 'message' in _ctx.uploadError ? _ctx.uploadError.message : _ctx.uploadError), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedFile && !_ctx.scheduleData)
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showParseConfirmation && _ctx.showParseConfirmation(...args))),
            class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
          }, " Parse Calendar "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.scheduleData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-xl font-semibold mb-4" }, "2. Relevant Meetings of Forecasting Period", -1)),
                _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, "Your scheduled meetings for the current forecasting period", -1)),
                (_ctx.currentPeriodMeetings.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPeriodMeetings, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "p-4 border rounded-lg"
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", null, [
                              _createElementVNode("h4", _hoisted_28, _toDisplayString(item.title), 1),
                              (item.comments)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(item.comments), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(item.type === 'meeting' ? 'Meeting' : item.type === 'process' ? 'Process' : 'Other'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[33] || (_cache[33] = _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(item.startDate)) + " ", 1),
                            (item.endDate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, " - " + _toDisplayString(_ctx.formatDate(item.endDate)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 1,
                      icon: "document",
                      title: "No Upcoming Meetings",
                      message: "There are no meetings scheduled for the current forecasting period.",
                      iconClass: "text-gray-400"
                    }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.scheduleData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "3. Saved Drafts", -1)),
                (_ctx.savedDrafts.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("table", _hoisted_35, [
                        _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Subject "),
                            _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Created At "),
                            _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Actions ")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedDrafts, (draft) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: draft.id
                            }, [
                              _createElementVNode("td", _hoisted_36, _toDisplayString(draft.subject), 1),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.formatDate(draft.createdAt)), 1),
                              _createElementVNode("td", _hoisted_38, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.loadEmailDraft(draft.id)),
                                  class: "text-blue-500 hover:text-blue-700 mr-2"
                                }, " Load ", 8, _hoisted_39),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.showDeleteConfirmation(draft.id, draft.subject)),
                                  class: "text-red-500 hover:text-red-700"
                                }, " Delete ", 8, _hoisted_40)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 1,
                      icon: "document",
                      title: "No Saved Drafts",
                      message: "You haven't saved any email drafts yet. After creating a draft, click 'Save Draft' to save it here.",
                      iconClass: "text-gray-400"
                    }))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          (_ctx.userData && _ctx.userData?.id)
            ? (_openBlock(), _createBlock(_component_ChatbotInterface, {
                key: 0,
                userData: _ctx.userData,
                environment: _ctx.currentEnv,
                userId: _ctx.userData?.id,
                class: "h-full",
                style: {"max-height":"800px","min-width":"600px","max-width":"600px","position":"sticky","top":"0"}
              }, null, 8, ["userData", "environment", "userId"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.emailDraft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "4. Email Draft Preview", -1)),
            _createElementVNode("div", _hoisted_43, [
              _cache[38] || (_cache[38] = _createElementVNode("label", {
                class: "block text-gray-700 text-sm font-bold mb-2",
                for: "email-subject"
              }, " Subject ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "email-subject",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailDraft.subject) = $event)),
                class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              }, null, 512), [
                [_vModelText, _ctx.emailDraft.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " HTML Content ", -1)),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", { innerHTML: _ctx.processedHtmlContent }, null, 8, _hoisted_46),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPreviewModal = true)),
                  class: "absolute top-2 right-2 bg-white p-1 rounded-md shadow hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                  title: "View in full screen"
                }, _cache[39] || (_cache[39] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 text-gray-500",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " Text Content ", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.emailDraft.textContent) = $event)),
                class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32",
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.emailDraft.textContent]
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[42] || (_cache[42] = _createElementVNode("label", {
                class: "block text-gray-700 text-sm font-bold mb-2",
                for: "draft-recipient"
              }, " Recipient Emails ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "draft-recipient",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.emailDraftRecipient) = $event)),
                type: "email",
                placeholder: "Enter recipient email addresses (comma separated)",
                class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              }, null, 512), [
                [_vModelText, _ctx.emailDraftRecipient]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _cache[43] || (_cache[43] = _createElementVNode("label", {
                class: "block text-gray-700 text-sm font-bold mb-2",
                for: "draft-cc"
              }, " CC Emails ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "draft-cc",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.emailDraftCC) = $event)),
                type: "email",
                placeholder: "Enter CC email addresses (comma separated)",
                class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              }, null, 512), [
                [_vModelText, _ctx.emailDraftCC]
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearEmailDraft && _ctx.clearEmailDraft(...args))),
                class: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              }, " Clear "),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveEmailDraft && _ctx.saveEmailDraft(...args))),
                class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              }, " Save Draft "),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.sendEmailDraft && _ctx.sendEmailDraft(...args))),
                disabled: !_ctx.emailDraft || !_ctx.emailDraftRecipient || _ctx.isEmailDraftSending,
                class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
              }, [
                (_ctx.isEmailDraftSending)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Sending..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_53, "Send Draft"))
              ], 8, _hoisted_51)
            ]),
            (_ctx.emailDraftStatus.message)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['mt-4 p-4 rounded', _ctx.emailDraftStatus.isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'])
                }, _toDisplayString(_ctx.emailDraftStatus.message), 3))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmationModal, {
      isOpen: _ctx.showConfirmDialog,
      "onUpdate:isOpen": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showConfirmDialog) = $event)),
      title: "Process File",
      message: `Do you want to process the file '${_ctx.selectedFile?.name || ''}'?`,
      confirmButtonText: "Process",
      cancelButtonText: "Cancel",
      iconType: "info",
      onConfirm: _ctx.parseFile
    }, null, 8, ["isOpen", "message", "onConfirm"]),
    _createVNode(_component_EmailPreviewModal, {
      isOpen: _ctx.showPreviewModal,
      "onUpdate:isOpen": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showPreviewModal) = $event)),
      subject: _ctx.emailDraft?.subject || '',
      htmlContent: _ctx.emailDraft?.htmlContent || '',
      textContent: _ctx.emailDraft?.textContent || ''
    }, null, 8, ["isOpen", "subject", "htmlContent", "textContent"]),
    _createVNode(_component_ConfirmationModal, {
      isOpen: _ctx.showDeleteModal,
      "onUpdate:isOpen": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showDeleteModal) = $event)),
      title: "Delete Email Draft",
      message: `Are you sure you want to delete the email draft '${_ctx.draftToDeleteSubject}'?`,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonClass: "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500",
      iconType: "warning",
      onConfirm: _ctx.confirmDelete
    }, null, 8, ["isOpen", "message", "onConfirm"]),
    _createVNode(_component_ConfirmationModal, {
      isOpen: _ctx.showMissingTypesModal,
      "onUpdate:isOpen": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showMissingTypesModal) = $event)),
      title: "Missing Meeting Types Detected",
      message: _ctx.getMissingTypesMessage(),
      confirmButtonText: "Acknowledge",
      cancelButtonText: "Close",
      confirmButtonClass: "bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500",
      iconType: "warning",
      onConfirm: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showMissingTypesModal = false)),
      onCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showMissingTypesModal = false))
    }, null, 8, ["isOpen", "message"])
  ]))
}